import {Component, OnInit} from '@angular/core';
import { AppBaseComponent } from "@utils";
import { ControlContainer, FormBuilder } from "@angular/forms";
import { CityService, MessageService } from "@services";

@Component({
  selector: 'app-renewal',
  templateUrl: './renewal.component.html',
  styleUrls: ['./renewal.component.scss']
})
export class RenewalComponent extends AppBaseComponent implements OnInit {

  public renewalForm;//: FormGroup;
  public departaments: any[] = [];
  public bogotaDepartamento: any = {};
  public municipios: any[] = [];
  public listFiles: any[] = [];

  constructor(public fb: FormBuilder,
              public cityService: CityService,
              private popupService: MessageService,
              private controlContainer: ControlContainer
  ) {
    super();
  }

  ngOnInit(): void {
    this.renewalForm = this.controlContainer.control;
    this.renewalForm = this.renewalForm.controls['renewalForm'];
    this.cityService.getDepartaments().subscribe(resp => {
      this.departaments = resp.data;
      const depa: any = this.departaments.find(depa => depa.idDepartamento == 3); //Bogota
      if (depa) {
        this.bogotaDepartamento = depa;
        this.renewalForm.get('renovationDepartmentId').setValue(depa.idDepartamento);
        this.cityService.getMunByDepaId(depa.idDepartamento).subscribe(resp => {
          this.municipios = resp.data
          this.renewalForm.get('renovationMunicipalityId').setValue(this.municipios[0]?.idMunicipio);
        });
      }
    });
  }

  public checkSelectedFile(event: any): void {
    let archivos = event.target.files;
    if (archivos.length > 1) {
      this.popupService.errorAlert('Solo puedes cargar un archivo', 3000);
      event.target.value = '';
    }

    if (archivos.length == 1 && archivos[0].type != "application/pdf") {
      event.target.value = '';
      this.popupService.errorAlert('Formato no valido, solo se admiten documentos en formato PDF', 3000);
    }

    const file = event.target.files[0] || null;
    this.renewalForm.patchValue({
      licenciaAnteriorFile: file
    });
    console.log(this.renewalForm.value)
  }

  getErrorMessage(field: string): string {
    let message;
    let campoObligatorio = "Es requerido";
    let fechaErronea = "La fecha no puede ser una fecha futura o superior a la de hoy";


    const onlyNumbers: Array<string> = ['resolutionToModify'];

    if(this.isTouchedField(this.renewalForm, field))
    {
      if(this.renewalForm?.get(field).hasError('invalidDate'))
      {
        message = fechaErronea;
      }
      else if(this.renewalForm?.get(field).hasError('required'))
      {
        message = campoObligatorio;
      }
      else if(this.renewalForm?.get(field).hasError('pattern') && onlyNumbers.includes(field) )
      {
        message = `Solo se admiten numeros`;
      }
    }

    return message;
  }

  verificarFecha( ){
    //Bloquea del calendario desplegable
    const datepicker = document.getElementById('fecha-resolucion-licencia-anterior');
    const today = new Date();
    let date = today.getDate() > 9 ? today.getDate() :
      `0${today.getDate()}`;
    let month = today.getMonth() > 9 ? today.getMonth() + 1 :
      `0${today.getMonth() + 1}`;
    let year = today.getFullYear();

    datepicker.setAttribute('max', `${year}-${month}-${date}`);

  }

}
